// extracted by mini-css-extract-plugin
module.exports = {"negativeFeedbackOption":"UnhelpfulFeedbackOptions_negativeFeedbackOption__cUTJQ"};